module.exports = "../fonts/SFUIText-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Bold.woff
// module id = 574
// module chunks = 0